// assets
import { IconSchool, IconChalkboard, IconUsers } from '@tabler/icons';

// constant
const icons = { IconSchool, IconChalkboard, IconUsers };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const users = {
  id: 'users',
  title: 'Users',
  type: 'group',
  children: [
    {
      id: 'teachers',
      title: 'Teachers',
      type: 'item',
      url: '/users/teachers',
      icon: icons.IconSchool,
      breadcrumbs: false
    },
    {
      id: 'classes',
      title: 'Classes',
      type: 'item',
      url: '/users/classes',
      icon: icons.IconChalkboard,
      breadcrumbs: false
    },
    {
      id: 'students',
      title: 'Students',
      type: 'item',
      url: '/users/students',
      icon: icons.IconUsers,
      breadcrumbs: false
    }
  ]
};

export default users;
